export const BAR_CONTROLS = {
    LOADING: 'Laden...',
    TILE: {
        CANCEL_FAVORITE: 'Annuleren als favoriet',
        MARK_FAVORITE: 'Aanmerken als favoriet',
        REMOVE_TILE: 'Tegel verwijderen'
    },
    REMARKS: {
        REMARK_BLOCKING_1: 'Er is 1 blokkerende opmerking',
        REMARK_BLOCKING_N: 'Er zijn {{count}} blokkerende opmerkingen',
        REMARK_IMPORTANT_1: 'Er is 1 belangrijke opmerking',
        REMARK_IMPORTANT_N: 'Er zijn {{count}} belangrijke opmerkingen',
        REMARK_INFO_1: 'Er is 1 informatieve opmerking',
        REMARK_INFO_N: 'Er zijn {{count}} informatieve opmerkingen',
        NO_REMARKS: 'Er werden geen opmerkingen geregistreerd.',
        DETAILS: 'Details',
        REQUEST: 'Aanvraag',
        TOTAL_SUMMARY: 'Overzicht opmerkingen'
    },
    CONFIRM: {
        OK: 'Bevestigen',
        CANCEL: 'Annuleren'
    },
    CLOSE_DIALOG_BUTTON: {
        CLOSE: 'Sluiten'
    },
    SEARCH_SCREEN: {
        SEARCH: 'Zoeken',
        SEARCH_CRITERIA: 'Zoekvelden',
        SEARCH_CRITERIA_RESET: 'Zoekvelden initialiseren',
        SEARCH_RESULT: 'Zoekresultaat',
        SEARCH_FIELDS_SHOW: 'Uitgebreide zoekvelden tonen',
        SEARCH_FIELDS_HIDE: 'Uitgebreide zoekvelden verbergen'
    },
    DATE_TIME_PICKER: {
        SELECTION_TITLE: {
            DATE_TIME: 'Datum en tijd kiezen',
            DATE: 'Datum kiezen',
            TIME: 'Tijd kiezen'
        }
    },
    SELECT_LIST: {
        SELECT: 'Selecteer'
    }
} as const;

export const GENERAL_UI_I18N = {
    SAVE: 'Opslaan',
    CANCEL: 'Annuleren',
    NEW: 'Nieuw',
    VIEW: 'Bekijken',
    ADD: 'Toevoegen',
    EDIT: 'Wijzigen',
    DELETE: 'Verwijderen',
    REMOVE: 'Verwijderen',
    REFRESH: 'Herladen',
    SEARCH: 'Zoeken',
    FILTER: 'Filteren',
    SORT: 'Sorteren',
    OVERVIEW: 'Overzicht',
    SEARCH_RESULTS: 'Zoekresultaten',
    DETAILS: 'Details'
} as const;
